const Headset: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M9.99935 2.5C6.32732 2.5 3.33268 5.49464 3.33268 9.16667V10C2.41602 10 1.66602 10.75 1.66602 11.6667V13.3333C1.66602 14.25 2.41602 15 3.33268 15H4.99935V10.8333V10V9.16667C4.99935 6.39536 7.22805 4.16667 9.99935 4.16667C12.7706 4.16667 14.9993 6.39536 14.9993 9.16667V10V10.8333V15V15.8333H11.5928C11.5067 15.5899 11.3474 15.3791 11.1367 15.2299C10.926 15.0807 10.6742 15.0004 10.416 15C10.0845 15 9.76655 15.1317 9.53213 15.3661C9.29771 15.6005 9.16602 15.9185 9.16602 16.25C9.16644 16.5657 9.28633 16.8696 9.5016 17.1006C9.71687 17.3316 10.0116 17.4725 10.3265 17.4951C10.3562 17.4983 10.3861 17.5 10.416 17.5H14.9993C15.9102 17.5 16.666 16.7442 16.666 15.8333V15C17.5827 15 18.3327 14.25 18.3327 13.3333V11.6667C18.3327 10.75 17.5827 10 16.666 10V9.16667C16.666 5.49464 13.6714 2.5 9.99935 2.5Z"
      />
    </svg>
  );
};

export default Headset;
